import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { get } from '../../../server/actions';
import { showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './customReactDatepicker.css'
import './reports.css';
import salesReportIcon from './../../../assets/img/mm/salesReport.png';
import download from 'downloadjs';
class ConsumptionPaymentReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: moment(props.reportDefaultDate || new Date()).startOf('M').toDate(),
            endDate: moment(props.reportDefaultDate || new Date()).endOf('M').toDate(),
            dailySalesReport: [],
            userInfo: getLoginDistrictInfo(),
        }
    }

    componentWillMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }

    getSystemDateTime = (date) => {
        let _datetime = moment(date, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")
        return _datetime;
    }
    downloadReport = (reportType) => {
        let districtID = this.state.userInfo.districtId;
        let schoolID = parseInt(this.props.selectSchool);
        const schoolYear = this.props.selectedSchoolYear || this.state.userInfo.schools[0].activeSchoolYear;
        const s_d_id = schoolID > 0 ? schoolID : 0;
        const d_id = schoolID == 0 ? districtID : 0;
        const start = moment(this.state.startDate).startOf('day').utc().format("YYYY-MM-DDTHH:mm:ss");
        const end = moment(this.state.endDate).endOf('day').utc().format("YYYY-MM-DDTHH:mm:ss");

        let _url = `/reports/consumptionAndPayments/${d_id}/${s_d_id}/${schoolYear}?startDate=${start}&endDate=${end}&reportType=${reportType}&access_token=`;
        this.setState({ loading: true })
        get(_url).then((response) => {
            if (!response.ok) {
                if (response.status === 400 || response.status === 417 || response.status === 422 || response.status == 500) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                _addNotificationError(res.statusMessage, this.props)
                throw Error(res.errorMessage);
            } else if (res.statusCode === 422) {
                throw Error(res.statusMessage);
            } else if (res.statusCode === 400) {
                throw Error(res.statusMessage);
            } else if (res.statusCode === 500) {
                throw Error(res.statusMessage);
            } else {
                if (res.status == 200) {
                    return res.blob();
                } else {
                    throw Error(res.statusMessage);
                }

            }
        }).then(blob => {
            let filename = "DailyReconciliationReport";
            if (reportType == 'PDF') {
                showFile(blob, filename);
            } else {

                download(blob,
                    filename + '.xlsx', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            }

            this.setState({ loading: false })
        }).catch((error) => {
            let msg = ''
            if (typeof error === 'string') {
                msg = error;
            } else {
                msg = error.message;
            }
            _addNotificationError(msg, this.props);
            this.setState({ loading: false })
        }
        );
    }

    render() {
        const { startDate, endDate } = this.state;
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget">
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">
                                    <img src={salesReportIcon} />
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>Daily Reconciliation Report</b></span>
                                </div>
                            </div>
                            <div className="reportCard-widget-meeting-points">
                                <div className="row form-group">
                                    <label class="col-sm-12 control-label">From Date</label>
                                    <div className="col-sm-12 ">
                                        <DatePicker wrapperClassName="fullWidthDatepicker"
                                            selected={startDate}
                                            onChange={(date) => {
                                                this.setState({ startDate: date }, () => {
                                                });
                                            }} className='form-control form-control-sm' />
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label class="col-sm-12 control-label">To Date</label>
                                    <div className="col-sm-12 ">
                                        <DatePicker wrapperClassName="fullWidthDatepicker"
                                            selected={endDate}
                                            onChange={(date) => {
                                                this.setState({ endDate: date }, () => {
                                                });
                                            }} className='form-control form-control-sm' />
                                    </div>
                                </div>

                            </div>
                            <div className='reportCard-widget-meeting-action'>
                                <div className="form-group">
                                    <button type='button' className='btn btn-sm btn-success' style={{ margin: '0px 5px 0px 0px' }} onClick={() => {
                                        this.downloadReport('PDF')
                                    }}>
                                        <i className="fa fa-file-pdf-o" /> Pdf
                                    </button>
                                    <button type='button' className='btn btn-sm btn-success' style={{ margin: '0px 5px 0px 0px' }} onClick={() => {
                                        this.downloadReport('XLSX')
                                    }}>
                                        <i className="fa fa-file-excel-o" /> Excel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
export default ConsumptionPaymentReport;


// WEBPACK FOOTER //
// ./src/components/District/Reports/consumption_paymentsReport.js